export default __webpack_public_path__ + "static/media/gallery_01.523cfec7.jpg";